<app-banner [heading]="'OUR INFRA - SCHOOL BUILDING'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-1.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6 class=""> Ultra Modern School Building</h6>
              
              <p>The ultra modern school building with plush interiors is equipped with ergonomic furniture, 
			  digital smart classes, modern laboratories, a well stocked library, and impressive studios for
			  art and craft, western and classical Indian dance and music.<br><br> It provides the children an ideal 
			  environment for academics and co-curricular activities.
			  
			  </p>
              
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-new.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-3.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-4.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-5.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-7.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/schoolbuilding/school-building-8.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 
		  
		</div>
      </div>
	</section><!-- End About Section -->
	
	
	
    
    
  </main>